<template>
    <el-dropdown
        trigger="click"
        popper-class="dropdown-style"
        @visible-change="handleLanVisibleChange"
    >
        <div class="language-header">
            <span class="earth"></span>
            {{ getCurrentLang }}
            <el-icon>
                <ArrowUp v-if="lanVisible" />
                <ArrowDown v-else />
            </el-icon>
        </div>
        <template #dropdown>
            <el-dropdown-menu>
                <el-dropdown-item
                    v-for="item in languageList"
                    :key="item.locale"
                    :class="getCurrentLang === item.value ? 'selected' : ''"
                    @click="changeLang(item.locale)"
                >
                    <div style="width: 110px; display: flex; justify-content: space-between; align-items: center">
                        <span>{{ item.label }}</span>
                        <el-icon v-if="getCurrentLang === item.value">
                            <Check />
                        </el-icon>
                    </div>
                </el-dropdown-item>
            </el-dropdown-menu>
        </template>
    </el-dropdown>
</template>

<script setup lang="ts">
import {ref, watch, computed,nextTick} from 'vue';
import {useRoute} from 'vue-router';
import { defineUserStore } from '@/stores/user';
import {useI18n} from 'vue-i18n';
const userStore = defineUserStore();

const {locale} = useI18n();
const route = useRoute();

const lanVisible = ref(false);
const handleLanVisibleChange = (val: boolean) => {
    lanVisible.value = val;
};

const allLanguageList = [
    {
        label: '中文（简体）',
        value: 'ZH',
        locale: 'cn'
    },
    {
        label: 'English',
        value: 'EN',
        locale: 'en'
    }
];
const languageList = ref(allLanguageList);

const getCurrentLang = computed(() => {
    const obj: any = languageList.value.find((item) => item.locale === locale.value) || languageList.value[0];
    // fix bug: default language is not set localstorage
    localStorage.setItem('lang', obj.locale);
    return obj.value;
});

const changeLang = (lang: string) => {
    nextTick(()=>{
        locale.value = lang;
        localStorage.setItem('lang', lang);
    })
    nextTick(() => {
        userStore.setComponentKey();
    });
};
</script>

<style lang="scss" scoped>
.language-header {
    height:30px;
    padding: 10px 16px;
    border: 1px solid #dcdfe6;
    border-radius: 8px;
    cursor: pointer;
    display: flex;
    align-items: center;
    gap: 4px;
    &:hover {
        border-color: var(--el-color-primary);
    }
    &[aria-expanded="true"] {
        border-color: var(--el-color-primary);
    }
    .earth {
        display: inline-block;
        width: 12px;
        height: 12px;
        background-size: 100%;
        background-image: url(../../assets/images/earth.png);
    }
}
</style>
<style lang="scss">
    .dropdown-style {
        .el-dropdown-menu__item.selected {
            color: var(--el-color-primary);
        }
    }
</style>
